package fr.manyverse.app.presentation.components.player_screen.character.choice

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.size
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.FilledIconButton
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.semantics.contentDescription
import androidx.compose.ui.semantics.semantics
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp

private const val DISABLED_ALPHA = 0.38f

/**
 * Bouton de choix de personnage, dans l'un de ses trois états.
 *
 * @param loading vérification en cours : un indicateur remplace l'icône, le bouton est inactif.
 * @param enabled une fois la vérification terminée, `false` signifie « rien à proposer » :
 * icône et libellé grisés, bouton inactif.
 *
 * Le gabarit (rond de 80.dp + libellé) est identique dans les trois états, pour que la zone de
 * choix ne se réagence jamais.
 */
@Composable
fun CharacterChoiceButton(
    label: String,
    icon: ImageVector,
    onClick: () -> Unit,
    modifier: Modifier = Modifier,
    enabled: Boolean = true,
    loading: Boolean = false
) {
    val isInteractive = enabled && !loading
    Column(
        horizontalAlignment = Alignment.CenterHorizontally,
        verticalArrangement = Arrangement.spacedBy(8.dp),
        modifier = modifier
    ) {
        FilledIconButton(
            onClick = onClick,
            enabled = isInteractive,
            modifier = Modifier.size(80.dp)
        ) {
            if (loading) {
                CircularProgressIndicator(
                    modifier = Modifier
                        .size(28.dp)
                        .semantics { contentDescription = label },
                    strokeWidth = 2.dp,
                    color = MaterialTheme.colorScheme.onPrimary
                )
            } else {
                Icon(
                    imageVector = icon,
                    contentDescription = label,
                    modifier = Modifier.size(36.dp)
                )
            }
        }
        Text(
            text = label,
            style = MaterialTheme.typography.labelMedium,
            textAlign = TextAlign.Center,
            color = if (enabled || loading) {
                MaterialTheme.colorScheme.onSurface
            } else {
                MaterialTheme.colorScheme.onSurface.copy(alpha = DISABLED_ALPHA)
            }
        )
    }
}
